import store from '@/store';
import { leaseType } from '@/util/dictList.js';
export const option = {
  height: 'auto',
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchSpan: 6,
  searchMenuSpan: 6,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: false,
  dialogClickModal: false,
  searchIcon: true,
  searchIndex: 7,
  searchLabelWidth: 100,
  rowKey: 'index',
  column: [
    {
      label: '主键id',
      prop: 'id',
      type: 'input',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: '进件编号',
      prop: 'businessCode',
      type: 'input',
      search: true,
      minWidth:120,
      searchOrder: 992,
    },
    {
      label: '所属代理商',
      prop: 'businessDeptName',
      type: 'input',
      minWidth:100,
      width: 90,
    },
    {
      label: '产品类型',
      prop: 'rentType',
      minWidth:100,
      type: 'select',
      dicData: store.getters.porductTypes,
    },
    {
      label: '产品类型',
      prop: 'rentTypeList',
      minWidth:100,
      type: 'select',
      search: true,
      searchMultiple: true,
      hide: true,
      showColumn: false,
      searchOrder: 999,
      dicData: store.getters.porductTypes,
    },
    {
      label: '租率',
      prop: 'rate',
      type: 'select',
      minWidth:80,
      search: false,
      dicData: [],
      props: {
        label: 'lable',
        value: 'rate',
      },
    },
    {
      label: '租期',
      prop: 'tenancy',
      minWidth:80,
      type: 'select',
      search: false,
      formatter: (val, value) => {
        return value ? value + '期' : '-';
      },
      dicData: leaseType,
    },
    {
      label: '租赁人',
      prop: 'name',
      type: 'input',
      minWidth:100,
      search: true,
      searchOrder: 998,
    },
    {
      label: '手机号',
      prop: 'phoneNumber',
      minWidth: 110,
      type: 'input',
    },
    {
      label: '车牌号',
      prop: 'carFirstNumber',
      type: 'input',
      minWidth:100,
      search: true,
      searchOrder: 997,
    },
    {
      label: '租赁金额',
      prop: 'leaseAmount',
      type: 'input',
      minWidth:100,
      search: false,
    },
    {
      label: '所属代理商',
      prop: 'businessDeptIdList',
      type: 'select',
      search: true,
      searchMultiple: true,
      searchOrder: 1000,
      hide: true,
      filterable: true,
      dicData: store.getters.companies,
      props: {
        label: 'title',
        value: 'id',
      },
    },
    {
      label: '所在部门',
      prop: 'corporateStep',
      type: 'select',
      searchOrder: 993,
      search: true,
      minWidth:100,
      formatter: (val, value) => {
        let label = '';
        if (value) {
          if (value === 101) {
            label = '催收';
          } else if (value === 106) {
            label = '行动';
          } else if (value === 107) {
            label = '谈判';
          } else if (value === 140) {
            label = '车辆管理';
          } else {
            label = '财务';
          }
        }
        return label;
      },
      dicData: [
        {
          label: '催收',
          value: 101,
        },
        {
          label: '行动',
          value: 106,
        },
        {
          label: '谈判',
          value: 107,
        },
        {
          label: '车辆管理',
          value: 140,
        },
        {
          label: '财务',
          value: 888,
        },
      ],
    },
    {
      label: '当前状态',
      prop: 'repaymentType',
      type: 'select',
      searchOrder: 994,
      search: true,
      hide: true,
      width: 100,
      dicData: [
        {
          label: '待还款',
          value: 1,
        },
        {
          label: '驳回',
          value: 4,
        },
      ],
    },
    {
      label: '当前流程状态',
      prop: 'followStatusName',
      type: 'select',
      minWidth:100,
      dicData: [
        {
          label: '待还款',
          value: 1,
        },
        {
          label: '入账中',
          value: 2,
        },
        {
          label: '已入账',
          value: 3,
        },
        {
          label: '驳回',
          value: 4,
        },
      ],
    },
    {
      label: '催收人',
      prop: 'collectorUserName',
      type: 'input',
      minWidth: 90,
      formatter: (val, value) => {
        return value || '没有催收过';
      },
    },
    {
      label: '催收次数',
      prop: 'collectorCount',
      type: 'input',
      minWidth: 90,
      formatter: (val, value) => {
        return value || '没有催收过';
      },
    },
    {
      label: '最近催收时间',
      prop: 'collectorCreateTime',
      type: 'input',
      minWidth:100,
      formatter: (val, value) => {
        return value || '没有催收过';
      },
    },
    {
      label: '客户还租日期',
      prop: 'currentLendingDateSearch',
      type: 'date',
      minWidth: 100,
      search: true,
      hide: true,
      searchRange: true,
      searchOrder: 996,
      searchType: 'daterange',
      valueFormat: 'yyyy-MM-dd',
      sortable: 'custom',
      order: '',
    },
    {
      label: '还租日查询',
      prop: 'dateInteger',
      type: 'select',
      search: true,
      searchMultiple: true,
      hide: true,
      showColumn: false,
      searchOrder: 995,
      dicData: (() => {
        let arr = [];
        for (let i = 1; i < 32; i++) {
          arr.push({
            label: i + '日',
            value: i,
          });
        }
        return arr;
      })(),
    },
  ],
};

//待还客户
export const stillOption = [
  {
    label: '客户期数',
    prop: 'currentTenancy',
    type: 'input',
    minWidth:100,
    // formatter: (val, value, label) => {
    //     return value ? (value + "/" + val['tenancy']) : "已完结";
    // },
  },
  {
    label: '客户还租日期',
    prop: 'currentLendingDate',
    type: 'date',
    minWidth: 120,
    valueFormat: 'yyyy-MM-dd',
    sortable: 'custom',
    order: '',
  },
  {
    label: '到期天数',
    prop: 'delayDays',
    minWidth: 100,
    type: 'input',
    slot: true,
    sortable: 'custom',
    order: '',
  },
  {
    label: '每期租金',
    minWidth:100,
    prop: 'lendingAmountPer',
    type: 'input',
    formatter: (val, value) => {
      return value ? value + '元' : '-';
    },
  },
  {
    label: '累计应还滞纳金',
    prop: 'totalNeedRepaymentOverdueFine',
    type: 'input',
    minWidth:120,
    formatter: (val, value) => {
      return value ? value + '元' : '-';
    },
  },
  {
    label: '本期应还',
    prop: 'duePeriod',
    type: 'input',
    minWidth:100,
    slot: true,
    showColumn: false,
  },
  // {
  //   label: '实付租金',
  //   prop: 'actualPayment',
  //   type: 'input',
  //   formatter: (val, value) => {
  //     return value ? value + '元' : '-';
  //   },
  // },
  // {
  //   label: '实付滞纳金',
  //   prop: 'actualPaymentOverdueFine',
  //   type: 'input',
  //   formatter: (val, value) => {
  //     return value ? value + '元' : '-';
  //   },
  // },
];

//逾期客户
export const overdueOption = [
  {
    label: '本期应还租期数',
    prop: 'currentTenancy',
    minWidth:120,
    type: 'input',
  },
  {
    label: '本期应还租日期',
    prop: 'currentLendingDate',
    minWidth:120,
    type: 'input',
  },
  {
    label: '本期逾期天数',
    prop: 'delayDays',
    minWidth:120,
    type: 'input',
  },
  {
    label: '累计逾期期数',
    prop: 'totalOverduePeriod',
    minWidth:120,
    type: 'input',
  },
  {
    label: '应还滞纳金',
    prop: 'totalNeedRepaymentOverdueFine',
    minWidth:120,
    type: 'input',
  },
  {
    label: '本期应还租金',
    prop: 'duePeriodRent',
    minWidth:120,
    type: 'input',
  },
  {
    label: '剩余未还租金',
    prop: 'remainingPeriod',
    minWidth:120,
    type: 'input',
  },
  // {
  //   label: '本期剩余未还滞纳金',
  //   prop: 'remainingPeriodOverdueFine',
  //   type: 'input',
  // },
  // {
  //   label: '当前移交部门',
  //   prop: 'currentHandoverDept',
  //   type: 'input',
  //   width: 100,
  // },
  // {
  //   label: '拖车状态',
  //   prop: 'tuoCarStatusName',
  //   type: 'input',
  // },
  // {
  //   label: '谈判状态',
  //   prop: 'negotiationStatusName',
  //   type: 'input',
  // },
  // {
  //   label: '诉讼状态',
  //   prop: 'litigationStatusName',
  //   type: 'input',
  // },
];
